import type { ComponentType } from '@grafikr/components';
import AOS from 'aos';

import 'aos/dist/aos.css';

/**
 * Wrapper component to initialize AOS on-demand.
 * Wrap your section inside a <div data-component="aos"> wrapper.
 *
 * On, or inside, the wrapper, use AOS normally - https://github.com/michalsnik/aos
 * AOS events / methods can also be added here.
 */
const Component: ComponentType = (node, { app }) => {
  const { onEvent } = node.dataset;

  if (onEvent) {
    app.emitter.on(onEvent, AOS.init);
  } else {
    AOS.init();
  }
};

export default Component;
